import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import { ProjectData } from "../../../models/ProjectData";

import "./styles.scss";

interface IProjectBasicInfoProps {
  project?: ProjectData;
}

export const ProjectBasicInfo: React.FC<IProjectBasicInfoProps> = ({
  project
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`projectManagementPage.projectBasicInfo.${key}`);

  return (
    <div className="white-border-panel project-basic-info">
      <h2 className="project-basic-info-title">{project?.name}</h2>
      <div className="project-basic-info-content">
        <div className="project-basic-info-content-item">
          <h3>{t("project_start_date")}</h3>
          <span className="project-basic-info-content-item-value">
            {dayjs(project?.project_start_date).format("YYYY/MM/DD")}
          </span>
        </div>
      </div>
    </div>
  );
};
